import React, { useEffect, useRef, useState, useCallback } from "react";
import "./VimeoVideo.scss";
import { getVimeoVideo } from "services/lecture";
import { errorResponse, failResponse } from "config/config";
import { FaExpand, FaCompress } from "react-icons/fa";

const VimeoVideo = ({ videoId, studentdetails }) => {
  const [embedUrl, setEmbedUrl] = useState("");
  const wrapperRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const getVimeoAuthorize = useCallback(async () => {
    try {
      const res = await getVimeoVideo({ videoId });
      if (res.code === 200) {
        setEmbedUrl(res.data.signedUrl || "");
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  }, [videoId]);

  const enterFullscreen = () => {
    wrapperRef.current?.requestFullscreen();
  };

  const exitFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const toggleFullscreen = () => {
    isFullscreen ? exitFullscreen() : enterFullscreen();
  };

  useEffect(() => {
    if (videoId) {
      getVimeoAuthorize();
    }
  }, [videoId, getVimeoAuthorize]);

  useEffect(() => {
    const onFsChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFsChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFsChange);
  }, []);

  if (!videoId || !embedUrl) return null;

  return (
    <div className="vimeo-wrapper" ref={wrapperRef}>
      <iframe src={`${embedUrl}&badge=0&title=0&byline=0&portrait=0&fullscreen=0`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Vimeo Video" />

      {/* Watermarks */}
      {/* <div className="video-watermark moving wm-1">
        {studentdetails?.StudentName || ""}
      </div>
      <div className="video-watermark moving wm-2">
        {studentdetails?.StudentEmail || ""}
      </div>
      <div className="video-watermark moving wm-3">
        {studentdetails?.StudentMobile || ""}
      </div> */}

      {/* Fullscreen toggle */}
      <button className="custom-fullscreen-btn" onClick={toggleFullscreen}>
        {isFullscreen ? (
          <FaCompress size={20} color="#fff" />
        ) : (
          <FaExpand size={20} color="#fff" />
        )}
      </button>
    </div>
  );
};

export default VimeoVideo;
